import * as XHR from 'i18next-xhr-backend';
import * as i18next from 'i18next';

export const DEFAULT_LANG = 'ko_KR';

const defaultConfig = {
  lng: DEFAULT_LANG,
  cookieName: 'PVPNET_LANG',
  react: {
    wait: true,
  },
  fallbackLng: false, //set to false to prevent async loading en_US every time.
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
  debug: process.env.NODE_ENV === 'development',
  backend: {
    loadPath: '{{lng}}',
    ajax: fetchTranslation,
    parse: (data) => data,
  },
};

function fetchTranslation(language, _options, callback, _data) {
  const success = (data) => callback(data, { status: '200' });
  const error = (_e) => {
    console.log(_e); // eslint-disable-line no-console
    return callback(null, { status: '404' });
  };

  import(`../locales/${language}.json`)
    .then(success)
    .catch(error);
}

export class I18n {
  private _i18n: i18next.i18n;

  get instance() {
    return this._i18n;
  }

  init(config?: i18next.InitOptions) {
    this._i18n = i18next.use(XHR).init(Object.assign(defaultConfig, config));
  }

  setLanguage(bcp47Lang: string) {
    if (this.instance && this.instance.language !== bcp47Lang) {
      return new Promise((resolve, reject) => {
        this.instance.changeLanguage(bcp47Lang, (err) =>
          err ? reject(err) : resolve()
        ); //eslint-disable-line no-confusing-arrow
      });
    }

    return Promise.resolve();
  }

  get language(): string {
    if (this.instance && this.instance.language) {
      return this.instance.language;
    }
  }
}

export default new I18n();



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/lib/i18n.ts